var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// eslint-disable-next-line max-classes-per-file
import moment from 'moment-timezone';
import { useApiQuery, useApiMutation, AuthApiQuery } from '../../../../../modules/infra/api';
import { endpoints } from '../../../../../modules/shared/appointments/walk-in-list/network';
import { getSessionShop, useSession } from '../../../../../modules/infra/session';
import Http from '../../../../http';
// Hook to get current walk-in list using the real API
export var useWalkInListQuery = function (isModalOpen) {
    if (isModalOpen === void 0) { isModalOpen = false; }
    var session = useSession().data;
    var shop = getSessionShop(session);
    // today with format YYYY-MM-DD
    var today = moment().format('YYYY-MM-DD');
    return useApiQuery({
        endpoint: endpoints.walkInListCurrentQuery,
        payload: {
            shopId: (shop === null || shop === void 0 ? void 0 : shop.id) || '',
            timezone: (shop === null || shop === void 0 ? void 0 : shop.timezone) || 'UTC',
            date: today,
        },
        options: {
            enabled: !!(shop === null || shop === void 0 ? void 0 : shop.id),
            // Auto-refetch every 30 seconds when modal is open
            refetchInterval: isModalOpen ? 30000 : false,
            // Only refetch when the window is focused
            refetchIntervalInBackground: false,
        },
    });
};
// Hook to get walk-in list history using the real API
export var useWalkInListHistoryQuery = function (date) {
    var session = useSession().data;
    var shop = getSessionShop(session);
    return useApiQuery({
        endpoint: endpoints.walkInListHistoryQuery,
        payload: {
            shopId: (shop === null || shop === void 0 ? void 0 : shop.id) || '',
            date: date,
            timezone: (shop === null || shop === void 0 ? void 0 : shop.timezone) || 'UTC',
        },
        options: {
            enabled: !!(shop === null || shop === void 0 ? void 0 : shop.id),
            refetchInterval: 30000,
        },
    });
};
// Waiting list current query endpoint using old Http class
var WaitingListCurrentQuery = /** @class */ (function (_super) {
    __extends(WaitingListCurrentQuery, _super);
    function WaitingListCurrentQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.meta = {
            cacheTime: 60 * 60 * 1000,
            staleTime: 60 * 60 * 1000,
        };
        return _this;
    }
    WaitingListCurrentQuery.prototype.getKey = function (payload) {
        return ['waiting-list-current', payload.shopId];
    };
    WaitingListCurrentQuery.prototype.request = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var today, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        today = moment().format('YYYY-MM-DD');
                        return [4 /*yield*/, Http.get("/shop/".concat(payload.shopId, "/waiting-list/customer/").concat(today), {
                                include: 'customer,services,barber',
                                sortBy: 'createdAt:asc',
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return WaitingListCurrentQuery;
}(AuthApiQuery));
// Waiting list history query endpoint using old Http class
var WaitingListHistoryQuery = /** @class */ (function (_super) {
    __extends(WaitingListHistoryQuery, _super);
    function WaitingListHistoryQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.meta = {
            cacheTime: 60 * 60 * 1000,
            staleTime: 60 * 60 * 1000,
        };
        return _this;
    }
    WaitingListHistoryQuery.prototype.getKey = function (payload) {
        return ['waiting-list-history', payload.shopId, payload.date];
    };
    WaitingListHistoryQuery.prototype.request = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // Use the old Http class directly like the existing waiting list implementation
                return [2 /*return*/, Http.get("/shop/".concat(payload.shopId, "/waiting-list/customer/").concat(payload.date), {
                        include: 'customer,services,barber',
                        sortBy: 'createdAt:asc',
                    })];
            });
        });
    };
    return WaitingListHistoryQuery;
}(AuthApiQuery));
// Hook to get current waiting list
export var useWaitingListCurrentQuery = function (isModalOpen) {
    if (isModalOpen === void 0) { isModalOpen = false; }
    var session = useSession().data;
    var shop = getSessionShop(session);
    return useApiQuery({
        endpoint: new WaitingListCurrentQuery(),
        payload: {
            shopId: (shop === null || shop === void 0 ? void 0 : shop.id) || '',
        },
        options: {
            enabled: !!(shop === null || shop === void 0 ? void 0 : shop.id),
            // Auto-refetch every 30 seconds when modal is open
            refetchInterval: isModalOpen ? 30000 : false,
            // Only refetch when the window is focused
            refetchIntervalInBackground: false,
        },
    });
};
// Hook to get waiting list history
export var useWaitingListHistoryQuery = function (date) {
    var session = useSession().data;
    var shop = getSessionShop(session);
    return useApiQuery({
        endpoint: new WaitingListHistoryQuery(),
        payload: {
            shopId: (shop === null || shop === void 0 ? void 0 : shop.id) || '',
            date: date,
        },
        options: {
            enabled: !!(shop === null || shop === void 0 ? void 0 : shop.id),
        },
    });
};
// Hook to add walk-in client using the real API
export var useAddWalkInClientMutation = function () {
    return useApiMutation({
        endpoint: endpoints.addWalkInClientMutation,
    });
};
// Hook to remove walk-in client using the real API
export var useRemoveWalkInClientMutation = function () {
    return useApiMutation({
        endpoint: endpoints.removeWalkInClientMutation,
    });
};
// Accept walk-in slot mutation
export var useAcceptWalkInSlotMutation = function () {
    return useApiMutation({
        endpoint: endpoints.acceptWalkInSlotMutation,
    });
};
// Notify walk-in slot mutation
export var useNotifyWalkInSlotMutation = function () {
    return useApiMutation({
        endpoint: endpoints.notifyWalkInSlotMutation,
    });
};
// Legacy API functions for backward compatibility (if needed)
export var walkInListApi = {
    // Get current walk-in list
    getCurrentWalkInList: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // This is now handled by useWalkInListQuery hook
            return [2 /*return*/, []];
        });
    }); },
    // Add client to walk-in list
    addWalkInClient: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // This is now handled by useAddWalkInClientMutation hook
            return [2 /*return*/, {}];
        });
    }); },
    // Remove client from walk-in list
    removeWalkInClient: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/];
        });
    }); },
    // Update walk-in client
    updateWalkInClient: function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // TODO: Implement using appropriate mutation
            return [2 /*return*/, {}];
        });
    }); },
};
